// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GuestLazyComponent" + "." + "0ca1b35cb8a361bcb018" + ".js";
};